import React from "react";
import { styled } from '@mui/styles';
import { CssBaseline } from "@mui/material";

//const GlobalStyle = createGlobalStyle`
//  html,
//  body,
//  #root {
//    height: 100%;
//  }

//  body {
//    background: ${props => props.theme && props.theme.body.background};
//  }
//`;

function LandingLayout(props) {
    
  return (
    <React.Fragment>
      <CssBaseline />
      {/*<GlobalStyle />*/}
      {props.children}
    </React.Fragment>
  );
}

export default LandingLayout;
